import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { ConfigurationPreformattedOntologyCreateRequest, ConfigurationPreformattedOntologyResponse } from '@/modules/configurationModule/detail/local-samples/preformatted/services/preformatted.dto'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'
import axios from 'axios'

class PreformattedConfigurationOntologyRelationshipServices {
    async getPreformattedRelationshipOntologies(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationPreformattedOntologyResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationPreformattedOntologyResponse>>(`/configuration/laboratories/${laboratoryId}/preformattedOntologies`, { ...filterModel }, { params })
        return response.data
    }
    async createPreformattedRelationshipOntologies(request: ConfigurationPreformattedOntologyCreateRequest, laboratoryId: number): Promise<ConfigurationPreformattedOntologyResponse> {
        const response = await axios.post<ConfigurationPreformattedOntologyResponse>(`/configuration/laboratories/${laboratoryId}/preformattedOntologies`, request)
        return response.data
    }
    async deletePreformattedRelationshipOntologies(preformattedOntologyId :number, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/preformattedOntologies/${preformattedOntologyId}`)
        return response.data
    }
}

export const preformattedConfigurationOntologyRelationshipServices = new PreformattedConfigurationOntologyRelationshipServices()
